<template>
  <div class="app-container">
    <div class="index-tree-box">
      <type-tree ref="type_tree" show-action @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
          </template>
          <template slot="column" v-if="$permission.canWrite()">
          </template>
        </list>
      </div>
    </div>
    <!-- <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" /> -->
  </div>
</template>
<script>

import curdMixins from "@/mixins/trend/curd";
import list from "@/components/scada/gather/transceiverassistant/taskdata/list";
import typeTree from "@/components/scada/gather/transceiverassistant/taskdata/tree";
// import editDialog from "@/components/personnel/result/record/editDialog";
// import importDialog from "@/components/personnel/result/record/importDialog";

export default {
  name: "taskdata",
  mixins: [curdMixins],
  components: {
    list,
    typeTree,
    // editDialog,
    // importDialog,
  },
  data() {
    return {
      select: {
        Id: null,
        Code: "",
        Name: "",
      },
    };
  },
  mounted() {
    this.$refs.type_tree.getData();
  },
  methods: {
    onImport() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    onSelect(data) {
      console.log("onSelect", data);
      this.select.DpId = data.DpId;
      this.select.DpName = data.DpName;
      this.select.EmpId = data.EmpId;
      this.select.EmpName = data.EmpName;
      this.$refs.list.getData({ PdaNo: data.PdaDeviceNo });
      // this.reload();
    },
    titleClick() {
      this.select.Id = null;
      this.select.Code = "";
      this.select.Name = "";
      this.$refs.list.getData({ IdChain: null });
    },
    create() {
      this.$refs.editDialog.openCreate({
        Pid: this.select.Id,
        Pcode: this.select.Code,
        Pname: this.select.Name,
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.EmpId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>